import { useEffect, useState } from "react";

export default function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 620);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href="#top"
      aria-label="返回顶部"
      className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-soft transition hover:bg-primary-600 ${
        show ? "gua-fade-up opacity-100" : "pointer-events-none opacity-0"
      }`}
    >
      <i className="ri-arrow-up-line text-xl"></i>
    </a>
  );
}